import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {RoutesDialogService} from "../../services/routes-dialog-service.service";

export class GenerateCustomRoutesButtonCtrl implements IController {
  serviceAreas: any;

  constructor(private routesDialogService: RoutesDialogService, private $log) {
  }

  generateCustomRoutes(event) {
    if (!_.isUndefined(this.serviceAreas)) {
      this.routesDialogService.generateCustomRoutes(event, this.serviceAreas);
    } else {
      this.$log.error('Faild to load service areas, generateCustomRoutesButton@generateCustomRoutes');
    }
  }

}

angular
  .module('bringoz.admin.routes')
  .component('generateCustomRoutesButton', {
    bindings: {
      serviceAreas: '<?'
    },
    template: require('./generate-custom-routes-button.html').default,
    controller: GenerateCustomRoutesButtonCtrl
  });
